/**
 * Barra flotante «Añadir al carrito» en ficha de producto:
 * visible cuando el CTA principal (#ProductAtcAnchor-*) no está en viewport.
 * El botón flotante reutiliza el submit real (mismo formulario / AJAX).
 */
(function () {
  'use strict';

  function variantImageUrl(variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }
    return '';
  }

  function init(root) {
    var scope = root && root.nodeType ? root : document;
    var el = scope.querySelector('.product-sticky-atc[data-section-id]');
    if (!el || el.dataset.stickyAtcReady === '1') return;

    var sectionId = el.dataset.sectionId;
    var anchor = document.getElementById('ProductAtcAnchor-' + sectionId);
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var stickyBtn = document.getElementById('ProductStickySubmit-' + sectionId);
    var stickyImg = document.getElementById('ProductStickyImg-' + sectionId);
    var stickyPrice = document.getElementById('ProductStickyPrice-' + sectionId);

    if (!anchor || !mainBtn || !stickyBtn) {
      el.hidden = true;
      return;
    }

    el.dataset.stickyAtcReady = '1';

    function syncStickyButton() {
      var span = mainBtn.querySelector('span');
      if (span && span.textContent) stickyBtn.textContent = span.textContent.trim();
      stickyBtn.disabled = mainBtn.hasAttribute('disabled');
      stickyBtn.classList.toggle('loading', mainBtn.classList.contains('loading'));
      var ad = mainBtn.getAttribute('aria-disabled');
      if (ad === 'true') stickyBtn.setAttribute('aria-disabled', 'true');
      else stickyBtn.removeAttribute('aria-disabled');
    }

    function syncStickyPrice() {
      var main = document.getElementById('price-' + sectionId);
      if (!main || !stickyPrice) return;
      stickyPrice.innerHTML = main.innerHTML;
    }

    syncStickyButton();
    syncStickyPrice();

    var mo = new MutationObserver(syncStickyButton);
    mo.observe(mainBtn, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
    });

    var hideAfterTransition = null;

    var io = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // Solo mostrar la sticky cuando el CTA principal ha salido POR ARRIBA
        // del viewport (ya se ha scrolleado más allá).
        // Si el ancla aún está debajo del viewport (no hemos llegado a ella),
        // NO debe aparecer aunque también esté fuera de pantalla.
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (hideAfterTransition) {
          clearTimeout(hideAfterTransition);
          hideAfterTransition = null;
        }
        if (show) {
          el.hidden = false;
          el.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              el.classList.add('product-sticky-atc--visible');
            });
          });
          syncStickyButton();
          syncStickyPrice();
        } else {
          el.classList.remove('product-sticky-atc--visible');
          el.setAttribute('aria-hidden', 'true');
          hideAfterTransition = setTimeout(function () {
            el.hidden = true;
            hideAfterTransition = null;
          }, 400);
        }
      },
      { threshold: 0, rootMargin: '0px' }
    );
    io.observe(anchor);

    var priceEl = document.getElementById('price-' + sectionId);
    if (priceEl) {
      var priceMo = new MutationObserver(function () {
        syncStickyPrice();
      });
      priceMo.observe(priceEl, { childList: true, subtree: true });
    }

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true') return;
      mainBtn.click();
    });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || String(event.data.sectionId) !== String(sectionId)) return;
        syncStickyButton();
        requestAnimationFrame(function () {
          requestAnimationFrame(syncStickyPrice);
        });
        var url = variantImageUrl(event.data.variant);
        if (stickyImg && url) stickyImg.src = url.replace(/&amp;/g, '&');
      });
    }

    document.addEventListener('product-info:loaded', function (ev) {
      var t = ev.target;
      if (t && t.id === 'MainProduct-' + sectionId) {
        syncStickyButton();
        syncStickyPrice();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target);
  });
})();
